import { InjectionToken } from '@angular/core';

import { Feature } from './feature-toggle.model';

export const ENABLED_BY_DEFAULT_FEATURES = new InjectionToken<Feature[]>('enabled_by_default_features');
